export const ENTITY_TYPE_VEHICLE_MODEL = 'Ng::VehicleModel';
export const ENTITY_TYPE_INSTALL_KIT = 'Ng::InstallKit';
export const ENTITY_TYPE_DEVICE_MODEL = 'Ng::DeviceModel';
export const DOCUMENT_TYPE_DEVICE_MODEL = 'Device Model Installation';

export const AUDIT_COMMENTS = {
    LINK_VEHICLE_MODEL_DOCUMENT: 'Upload device model attachment',
    UNLINK_VEHICLE_MODEL_DOCUMENT: 'Unlink device model attachment'
  };